export function Logo({ className = "h-8", onDark = false }) {
  const img = <img src="/vybe-logo.png" alt="VybeMeter" className={className} data-testid="brand-logo" />;
  if (onDark) {
    return <span className="bg-white rounded-xl px-2.5 py-1.5 inline-flex items-center shadow-sm">{img}</span>;
  }
  return img;
}
